import { techTrustStripData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function TechTrustStrip() {
  return (
    <section className="py-6 md:py-8 bg-background-100 border-y border-background-200/50">
      <div className="container-astro">
        <AnimatedSection>
          <p className="text-center text-[11px] md:text-xs font-bold text-foreground-500 uppercase tracking-[0.2em] mb-5 md:mb-6 font-heading">
            {techTrustStripData.heading}
          </p>
        </AnimatedSection>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 lg:gap-14">
          {techTrustStripData.items.map((item, i) => (
            <AnimatedSection key={item.name} delay={i * 60}>
              <div className="group flex flex-col items-center gap-2 cursor-default">
                {item.isCustom ? (
                  <div
                    className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-accent-500/10 border border-accent-500/20 transition-all duration-300 ${item.color}`}
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${item.icon} text-lg`} />
                    </span>
                  </div>
                ) : (
                  <div
                    className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-background-50 border border-background-200/60 transition-all duration-300 group-hover:border-accent-300/40 group-hover:shadow-sm ${
                      item.featured ? "ring-2 ring-accent-500/20" : ""
                    }`}
                  >
                    <img
                      src={item.logo}
                      alt={item.name}
                      className={`object-contain transition-transform duration-300 group-hover:scale-110 ${
                        item.featured ? "h-6 md:h-7" : "h-5 md:h-6"
                      }`}
                      style={{ width: "auto", maxWidth: "36px" }}
                      loading="lazy"
                    />
                  </div>
                )}
                <span
                  className={`text-[11px] md:text-xs font-semibold font-heading transition-colors duration-300 ${
                    item.featured
                      ? "text-accent-600"
                      : "text-foreground-500 group-hover:text-accent-600"
                  }`}
                >
                  {item.name}
                </span>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}